import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { VerificationType } from '../app/VerificationType';
import { Data } from 'signup-constants/signupData/Data';
import { useSignupData } from '../signup-data/useSignupData';
import { setIsNewUser, setVerificationType } from '../store/app/action-creators';
import { useTrackSignupInitiated } from '../tracking/useTrackSignupInitiated';
import { useView } from '../views/useView';
import { ExperimentKeys } from '../experiments/ExperimentKeys';
import { useExperiment, TrackWhen } from '../experiments/useExperiment';
import { ExperimentParameterGroup } from '../experiments/ExperimentParameterGroup';
export const useLandingPage = stepKey => {
  const {
    submit
  } = useView({
    stepKey
  });
  const {
    setData: setToken
  } = useSignupData(Data.Token);
  const dispatch = useDispatch();
  const {
    isAssignedToSpecificVariant: isAssignedToSpecificVariantACQ142
  } = useExperiment(ExperimentKeys.ACQ0142, TrackWhen.never);
  useEffect(() => {
    dispatch(setIsNewUser(true));
  }, [dispatch]);
  const isAssignedToAcq142VariantB = isAssignedToSpecificVariantACQ142(ExperimentParameterGroup.Variant_B);
  useTrackSignupInitiated(!isAssignedToAcq142VariantB);
  const chooseEmailSignUp = () => {
    setToken(null);
    dispatch(setVerificationType(VerificationType.EmailByCode));
    submit();
  };
  return {
    chooseEmailSignUp
  };
};